import { iaRa } from 'lib/helpers/utility';

const STRENGTH_TOKEN = /^(\d*\.?\d+)([a-z%]*)$/i;
const UNIT_WORDS = new Set(['mg', 'mcg', 'ug', 'meq', 'ml', 'g', 'iu', '%', 'unit', 'units']);

export const NDC_SEARCH_LIMIT = 100;

export const parseMedicationSearch = (text = '') => {
  const nameWords = [];
  let strength = null;

  String(text ?? '')
    .trim()
    .split(/\s+/)
    .forEach((token) => {
      const strengthMatch = token.match(STRENGTH_TOKEN);
      if (strengthMatch) {
        // openFDA stores sub-1 strengths without the leading zero (".5 mg/1")
        if (!strength) strength = strengthMatch[1].replace(/^0+(?=\.)/, '');
        return;
      }
      const word = token.replace(/[^a-z0-9-]/gi, '');
      if (word && !UNIT_WORDS.has(word.toLowerCase())) nameWords.push(word);
    });

  return { nameWords, strength };
};

export const buildNdcSearchQuery = ({ nameWords, strength }) =>
  [
    ...nameWords.map((word) => `generic_name:*${word}*`),
    ...(strength ? [`active_ingredients.strength:${strength}*`] : [])
  ].join('+AND+');

const ingredientStrengths = (result) =>
  iaRa(result?.active_ingredients)
    .map((ingredient) => ingredient?.strength)
    .filter(Boolean);

export const getNdcStrengthText = (result) =>
  ingredientStrengths(result)
    .map((strength) => strength.replace(/\/1$/, '').replace(/^\./, '0.'))
    .join(' / ');

const PER_UNIT_STRENGTH = /^(\d*\.?\d+) (\S+)\/1$/;
const NDC_TO_FORM_UNIT = { mg: 'mg', ug: 'mcg', g: 'g', '[iU]': 'IU' };

export const getNdcStrengthAndUnit = (result) => {
  const [first, ...rest] = ingredientStrengths(result);
  if (!first || rest.length) return null;

  const [, strength, ndcUnit] = first.match(PER_UNIT_STRENGTH) ?? [];
  const unit = NDC_TO_FORM_UNIT[ndcUnit];
  return unit ? { strength: strength.replace(/^\./, '0.'), unit } : null;
};

export const uniqueNdcResults = (results, strength = null) => {
  const seen = new Set();

  return iaRa(results).filter((result) => {
    if (strength && !ingredientStrengths(result).some((s) => s.split(' ')[0] === strength)) {
      return false;
    }

    const key = [
      result?.generic_name,
      result?.dosage_form,
      iaRa(result?.route).join('/'),
      getNdcStrengthText(result)
    ]
      .join('|')
      .toLowerCase();

    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
